import { Serializable } from '@admin/core/models/serializable';
import { FeatureModel } from '@admin/shared/models/feature-model';

export class PermissionFilterModel
  implements Serializable<PermissionFilterModel>
{
  fromObject(obj: any): PermissionFilterModel {
    throw new Error('Not Implemented');
  }
  toObject() {
    let result = {
      FeatureType: this.featureType,
    };
    return result;
  }

  public featureType: number;

  constructor() {
    this.featureType = null;
  }
}
